import { roleGuarded } from '@/components/shell/RoleState';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { OnboardingFrame } from '@/features/onboarding/OnboardingFrame';
import { cachedSession } from '@/lib/session';

const steps = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

// A step outside 1–9, or above current_step while onboarding is unfinished, opens the current step; a step above it
// already done or skipped (an Operator, a webhook) can be reopened (merchant screens §3.1, the wizard frame).
export const Route = createFileRoute('/onboarding/$step')({
  staticData: { roles: ['owner'] },
  validateSearch: z.object({ result: z.string().optional() }),
  beforeLoad: async ({ context, params }) => {
    const merchant = cachedSession(context)?.merchant;
    if (!merchant) return;
    const current = merchant.onboarding_current_step;
    const toCurrent = redirect({ to: '/onboarding/$step', params: { step: String(current) } });
    if (!steps.includes(params.step)) throw toCurrent;
    if (merchant.onboarding_complete || Number(params.step) <= current) return;
    const onboarding = await context.queryClient
      .ensureQueryData(context.api.$api.queryOptions('get', '/api/onboarding'))
      .catch(() => null);
    // GET /onboarding is the wizard's own record (merchant screens §3.1 Data): its current_step can be ahead of the
    // session's, e.g. right after the checkout marked step 8 done.
    const step = Number(params.step);
    const status = onboarding?.steps.find((item) => item.step === step)?.status;
    if (status === 'done' || status === 'skipped' || step <= (onboarding?.current_step ?? current))
      return;
    throw redirect({
      to: '/onboarding/$step',
      params: { step: String(onboarding?.current_step ?? current) },
    });
  },
  component: roleGuarded(OnboardingFrame),
});
